import React from 'react'
import {Switch, Route} from 'react-router-dom'
import OnBoarding from "./onboarding";
import Display from "./display";

const TemplateUrlPath = (strings, ...keys) => {
        return (function(...values) {
                if(!keys || !values){
                        return strings
                }
                let dict = values[values.length - 1] || {};
                let result = [strings[0]];
                keys.forEach(function(key, i) {
                        let value = Number.isInteger(key) ? values[key] : dict[key];
                        result.push(value, strings[i + 1]);
                });
                return result.join('');
        });
}



const RouteStrings = {
    OnBoarding: {path: "/", component: OnBoarding, template: TemplateUrlPath`/`},
    Display: {path: "/:zip/:type", component: Display, template: TemplateUrlPath`/${0}/${1}`},
}


const Routes = () => {
        let routeElements = [];
        for (let [key, value] of Object.entries(RouteStrings)) {
            routeElements.push(<Route exact key={key} path={value.path} component={value.component}/>)
        }
        return (
            <Switch>
                {routeElements}
            </Switch>
        )
    }
;

export {Routes, RouteStrings}
